<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" :key="key" @input="closeInput")
      button.button.success(slot="trigger", v-if="policyProp") Edit
      a.fa-stack.fa-lg(slot="trigger", v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .column
          label Name
            input(type="text", v-model="policy.name")
          label Max bookable hours
            input(type="number", v-model="policy.configuration.max_bookable")
          label Min bookable time in minutes
            input(type="number", v-model="policy.configuration.min_bookable")


        .column
          //label Type
            select(v-model="policy.type")
              option DRIVER
              option VEHICLE
          label Booking Days
          .row
            .column.shrink(v-for="day in ['mon','tue','wed','thu','fri','sat','sun']")
              label {{day}}&nbsp;
                input(type="checkbox", v-model="policy.configuration.booking_days", :value="day")
          label Booking hours
          .row
            .column
              label Start
                input(type="text", v-model="policy.configuration.booking_hours.start", placeholder="HH:mm")
                .help-text(v-if="!startValid") Invalid format (HH:mm)
            .column
              label End
                input(type="text", v-model="policy.configuration.booking_hours.end", placeholder="HH:mm")
                .help-text(v-if="!endValid") Invalid format (HH:mm)
      ActionButton(slot="footer", :action="save", :disabled="!startValid || !endValid") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel


</template>

<script>
  import DatePicker from '../../components/structure/DatePicker'
  import StartEndTimePicker from './StartEndTimePicker'
  import ModalReveal from '../../components/structure/foundation/ModalReveal'
  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import MaggieHelper from '../../maggieHelper'
  import ActionButton from '../../components/structure/ui/ActionButton'

  export default {
    name: 'PolicyReveal',
    components: {ActionButton, ModalReveal, StartEndTimePicker, DatePicker},
    data() {
      return {
        policy: {
          name: null,
          type: 'DRIVER',

          configuration: {
            booking_days: [],
            max_bookable: 24,
            min_bookable: null,
            booking_hours: {start: null, end: null}
          }
        },
        key:0
      }
    },
    created() {
      if (this.policyProp !== null) {
        for (let key in this.policyProp) {
          if (key === 'configuration') {
            for (let confKey in this.policyProp.configuration) {
              this.policy.configuration[confKey] = this.policyProp.configuration[confKey]
            }
          } else {
            this.policy[key] = this.policyProp[key]
          }

        }
      }
    },
    methods: {
      checkHour(value) {
        const pattern = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/
        if (value === null || value === '') {
          return true
        }
        return pattern.test(value)
      },
      closeInput(event) {
        if(!event) {
          this.policy = {
            name: null,
            type: 'DRIVER',

            configuration: {
              booking_days: [],
              max_bookable: 24,
              min_bookable: null,
              booking_hours: {start: null, end: null}
            }
          }
          this.key++
        }
      },
      save() {
        if (this.policyProp === null) {
          return KeplerBackofficeSdk.policies.make(this.policy, () => {
            MaggieHelper.notification('', 'policy created')
            this.key++
            location.reload()
            this.$refs[this.componentId].close()

          })
        }

        return KeplerBackofficeSdk.policies.select(this.policy.id).edit(this.policy, (data) => {
          MaggieHelper.notification('', 'policy updated')
          this.key++
          location.reload()
          this.$refs[this.componentId].close()

        })
      }
    },
    computed: {
      componentId() {
        return this.policyProp !== null ? `voidReveal-${this.policyProp.id}` : `voidReveal-${this._uid}`
      },
      startValid() {
        const pattern = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/
        if (this.policy.configuration.booking_hours.start === null || this.policy.configuration.booking_hours.start === '') {
          return true
        }
        return pattern.test(this.policy.configuration.booking_hours.start)
      },
      endValid() {
        const pattern = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/
        if (this.policy.configuration.booking_hours.end === null || this.policy.configuration.booking_hours.end === '') {
          return true
        }
        return pattern.test(this.policy.configuration.booking_hours.end)
      }
    },
    props: {
      policyProp: {
        type: Object,
        default: null
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PolicyReveal.vue?c96b793a